import {ModalV3} from "../../../../../helpers/modals/ClassBased/ModalV3";
import {hideLoading, setLoadingMessage, showLoading} from "../../../../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../../../../helpers/handleAjaxError";
import {setAsSelect2} from "../../../../../helpers/inputs";
import createElement from "../../../../../helpers/createElement";
import {formatDateForGanttChart} from "../ganttWrapper";
import {getInputsByName} from "../../../../../helpers/forms";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file

class TimelinePrintModal extends ModalV3 {
	/** @var {TimelinePrintModalDefs.Config} */
	config;
	/** @var {WindowProxy} */
	printWindow;

	/** @var {HTMLElement} */
	taskPrintSettings;
	/** @var {HTMLElement} */
	ganttPrintSettings;
	/** @var {HTMLElement} */
	choosePrintTypeContainer;
	/** @var {HTMLElement} */
	footerContainer;
	/** @var {undefined|'tasks'|'gantt'} */
	printType;

	constructor(config) {
		super(config);
		this.config = config;

		// Init modal  We can do this here because this modal will never be replaced

		//// Init containers
		this.choosePrintTypeContainer = this.modalContainer.querySelector('.choose-print-type-container');
		this.ganttPrintSettings = this.modalContainer.querySelector('.print-gantt-settings');
		this.taskPrintSettings = this.modalContainer.querySelector('.print-tasks-settings');
		this.footerContainer = this.modalContainer.querySelector('.modal-footer');

		this.modalContainer.querySelector('.print-gantt-button').addEventListener(
			'click', () => this.displayGanttPrintSettings()
		);
		this.modalContainer.querySelector('.print-tasks-button').addEventListener(
			'click', () => this.displayTasksPrintSettings()
		);

		// Init submit button
		this.modalContainer.querySelector('.confirm-button')
			.addEventListener('click', () => this.handlePrintRequest());

		////// Init gantt print related settings

		//// Init selects
		// Make view type select a select2 instance
		const viewTypeSelect = this.getViewTypeSelect();
		setAsSelect2(viewTypeSelect, {
			dropdownParent: this.modalContainer,
		});

		// Make view type select a select2 instance
		const orientationSelect = this.getOrientationSelect();
		setAsSelect2(orientationSelect, {
			dropdownParent: this.modalContainer,
		});

		$(orientationSelect).on('change', () => {
			this.handleOrientationChange()
		})

		// Make view type select a select2 instance
		const paperSizeForGanttPrint = this.getPaperSizeForGanttPrint();
		setAsSelect2(paperSizeForGanttPrint, {
			dropdownParent: this.modalContainer,
		});

		$(paperSizeForGanttPrint).on('change', () => {
			this.handlePaperSizeChange()
		});

		// Set paper size select as custom if any paper size input is changed
		[
			this.getPaperWidthInput(),
			this.getPaperHeightInput()
		].forEach(input => {
			input.addEventListener('change', () => {
				$(paperSizeForGanttPrint).val('custom');
				$(paperSizeForGanttPrint).trigger('change');
			})
			input.addEventListener('keydown', () => {
				$(paperSizeForGanttPrint).val('custom');
				$(paperSizeForGanttPrint).trigger('change');
			})
		});

		// Setup task select options
		const taskSelect = this.getTaskTargetSelect();

		// Default All Option
		taskSelect.appendChild(createElement('<option value="printable-only">Public Only</option>'))
		taskSelect.appendChild(createElement('<option value="all">All Tasks</option>'))

		// Get tasks from gantt chart
		this.config.gantt._getTasks().forEach(task => {
			taskSelect.appendChild(createElement(`<option value="${task.id}">${task.name}</option>`))
		});

		// Make task select a select2 instance
		setAsSelect2(taskSelect, {
			templateResult: (taskOption) => {
				const relatedTask = this.config.gantt._findTaskById(taskOption.id);

				const indents = relatedTask ?
					this.config.gantt._getTaskParents(relatedTask).length :
					0;

				let indentsHtml = '';
				for (let x = 0; x < indents; x++) {
					indentsHtml += '<span class="ml-2"></span>';
				}

				return $(`${indentsHtml} <span>${taskOption.text}</span>`)
			},
			dropdownParent: this.modalContainer,
		});

		// We need to add w-100 to the select2 containers because it is initialized off screen
		// noinspection JSUnresolvedVariable
		[
			viewTypeSelect,
			taskSelect,
			orientationSelect,
			paperSizeForGanttPrint,
		].forEach(select => {
			$(select).data('select2').$container.addClass('w-100');
		});

		// Initial render
		this.handleOrientationChange();
		this.handlePaperSizeChange();

		////// Init task print related settings

		// Make view type select a select2 instance
		const paperSizeForTimeSheetPrint = this.getPaperSizeForTimeSheetPrint();
		setAsSelect2(paperSizeForTimeSheetPrint, {
			dropdownParent: this.modalContainer,
		});

		// We need to add w-100 to the select2 containers because it is initialized off screen
		// noinspection JSUnresolvedVariable
		[
			paperSizeForTimeSheetPrint,
		].forEach(select => {
			$(select).data('select2').$container.addClass('w-100');
		});
	}

	display(firstTime) {
		// Reinitialize containers visibility
		this.taskPrintSettings.classList.add('d-none');
		this.ganttPrintSettings.classList.add('d-none');

		this.choosePrintTypeContainer.classList.remove('d-none');
		this.choosePrintTypeContainer.classList.add('d-flex');

		this.footerContainer.classList.add('d-none');

		this.printType = undefined;

		super.display(firstTime);
	}

	displayGanttPrintSettings() {
		this.ganttPrintSettings.classList.remove('d-none');

		this.choosePrintTypeContainer.classList.add('d-none');
		this.choosePrintTypeContainer.classList.remove('d-flex');

		this.footerContainer.classList.remove('d-none');

		this.printType = 'gantt';
	}

	displayTasksPrintSettings() {
		this.taskPrintSettings.classList.remove('d-none');

		this.choosePrintTypeContainer.classList.add('d-none');
		this.choosePrintTypeContainer.classList.remove('d-flex');

		this.footerContainer.classList.remove('d-none');

		this.printType = 'tasks';
	}

	handlePrintRequest() {
		if (this.printType === 'gantt') {
			this.handleGanttPrintRequest();
		} else {
			this.handleTasksPrintRequest();
		}
	}


	////// Gantt/Timeline Print Related Settings

	handleGanttPrintRequest() {
		showLoading();
		Axios.post(
			this.config.gantt._wrapperOptions.getPrintWindowHtmlRoute,
			{
				orientation: this.getOrientationSelect().value,
				width: this.getPaperWidthInput().value,
				height: this.getPaperHeightInput().value,
			}
		)
			.then(async (response) => {
				// DISPLAY PRINT WINDOW
				await this.setupPrintWindow(response.data.html);
			})
			.catch(handleAjaxError)
			.finally(hideLoading)
	}

	/**
	 * @returns {HTMLSelectElement}
	 */
	getViewTypeSelect() {
		return this.modalContainer.querySelector('select[name="gantt_view_type"]');
	}

	/**
	 * @return {'month'|'quarter'}
	 */
	getViewType() {
		return this.getViewTypeSelect().value;
	}

	getOrientationSelect() {
		return this.modalContainer.querySelector('select[name="orientation"]');
	}

	/**
	 * @returns {HTMLSelectElement}
	 */
	getTaskTargetSelect() {
		return this.modalContainer.querySelector('select[name="gantt_task"]');
	}

	/**
	 * @return {GanttWrapper.Task|null}
	 */
	getTargetTask() {
		const taskId = this.getTaskTargetSelect().value;

		if (
			taskId === 'all' ||
			taskId === 'printable-only'
		) {
			return null;
		}

		return this.config.gantt._findTaskById(taskId);
	}

	getPaperSizeForGanttPrint() {
		return this.modalContainer.querySelector('.print-gantt-settings select[name="paper_size"]');
	}

	getPaperSizeForTimeSheetPrint() {
		return this.modalContainer.querySelector('.print-tasks-settings select[name="paper_size"]');
	}

	/**
	 * @return {
	 *    'letter'|
	 *    'legal'|
	 *    'custom'|
	 *    'tabloid' |
	 *    'A3' |
	 *    'A4' |
	 *    'A5'
	 * 	}
	 */
	getPaperSize() {
		if (this.printType === 'gantt') {
			return this.getPaperSizeForGanttPrint().value;
		} else {
			return this.getPaperSizeForTimeSheetPrint().value;
		}
	}

	getPaperWidthInput() {
		return this.modalContainer.querySelector('input[name="width"]');
	}

	getPaperHeightInput() {
		return this.modalContainer.querySelector('input[name="height"]');
	}

	/**
	 * @returns {HTMLInputElement}
	 */
	getRowsPerPageInput() {
		return this.modalContainer.querySelector('input[name="rows_per_page"]')
	}

	/**
	 * @returns {'portrait'|'landscape'}
	 */
	getExportOrientation() {
		// noinspection JSUnresolvedReference
		return this.getOrientationSelect().value;
	}

	handleOrientationChange() {
		// Set default rows per page for the selected orientation
		const input = this.getRowsPerPageInput();

		input.value = this.getDefaultRowsPerPage().toFixed(0);
	}

	/**
	 * Returns the default rows per page for the
	 * selected orientation/paper size bombo
	 */
	getDefaultRowsPerPage() {
		const orientation = this.getExportOrientation();
		// For letter size
		if (orientation === 'portrait') {
			return 25;
		} else {
			return 17;
		}
	}

	handlePaperSizeChange() {
		// Set default rows per page for the selected orientation
		const widthInput = this.getPaperWidthInput();
		const heightInput = this.getPaperHeightInput();

		// Update inputs with default values
		if (this.getPaperSize() !== 'custom') {
			const {height, width} = this.getDefaultWidthAndHeightForPaperSize();

			widthInput.value = width.toFixed(1);
			heightInput.value = height.toFixed(1);
		}
	}

	getDefaultWidthAndHeightForPaperSize() {
		const paperSize = this.getPaperSize()

		const result = {};

		switch (paperSize) {
			case "letter":
				result.width = 8.5;
				result.height = 11;
				break;
			case "legal":
				result.width = 8.5;
				result.height = 14;
				break;
			case "tabloid":
				result.width = 11;
				result.height = 17;
				break;
			case "A3":
				result.width = 11.7;
				result.height = 16.5;
				break;
			case "A4":
				result.width = 8.3;
				result.height = 11.7;
				break;
			case "A5":
				result.width = 5.8;
				result.height = 8.3;
				break;
			case "custom":
				result.height = 1;
				result.width = 1;
				break;
		}

		return result;
	}

	/**
	 * @return {number}
	 */
	getRowsPerPage() {
		const inputValue = parseInt(this.getRowsPerPageInput().value);

		if (isNaN(inputValue) || inputValue < 1) {
			return this.getDefaultRowsPerPage();
		}

		return inputValue;
	}

	async setupPrintWindow(html) {
		// Create new window with server returned HTML
		this.printWindow = window.open("", "title", "attributes");
		this.printWindow.document.write(html);
		this.printWindow.document.close();
		this.printWindow.focus();

		const windowBody = this.printWindow.document.querySelector('body');

		showLoading(windowBody);

		setLoadingMessage('Exporting Timeline', windowBody)

		// Get export type
		const exportType = this.getViewType();
		// Setup gantt for selected export type
		switch (exportType) {
			case "month":
				await this.exportTimelineByMonth();
				break;
			case "quarter":
				await this.exportTimelineByQuarter();
				break;
		}

		// After page building is finished, delete templates
		// we mainly do this to delete the SVG pattern in the
		// page template, as it breaks the actual pattern
		// Plus it should make the final PDF a bit smaller
		windowBody.querySelector('.templates').remove()

		// Wait a bit to make sure everything is ready for printing
		await new Promise(r => setTimeout(r, 512));


		// Init Print Dialogue
		this.printWindow.print();

		hideLoading(windowBody)

		// Close print window after printing
		this.printWindow.close();
	}

	async exportTimelineByMonth() {
		const ganttInstance = this.config.gantt;

		const {originalSvg, dateAnchorContainer, stickyDatesHeader} = await
			this.getComponentsFromOriginalGantt('Day');

		//// Prepare window for printing

		// Get page template
		const pageTemplate = this.printWindow.document.querySelector('.templates .page');

		// Get pages container
		const pagesContainer = this.printWindow.document.querySelector('.pages');

		// Create a page for each month in the timeline
		// noinspection JSCheckFunctionSignatures
		const months = this.filterUnnecessaryPeriods(ganttInstance._getTimelineMonths());

		for (const month of months) {
			// Break down period into chunks
			const chunks = this.getTasksChunks();

			const totalChunks = chunks.length
			chunks.forEach((chunk, index) => {
				////// Setup individual page
				const page = pageTemplate.cloneNode(true)

				// Set page title
				this.buildPageTitle(page, month, totalChunks, index + 1);

				// noinspection JSCheckFunctionSignatures
				this.buildPage(
					page,
					month,
					pagesContainer,
					originalSvg,
					dateAnchorContainer,
					stickyDatesHeader,
					chunk
				);
			})
		}
	}

	async exportTimelineByQuarter() {
		const ganttInstance = this.config.gantt;

		const {originalSvg, dateAnchorContainer, stickyDatesHeader} = await
			this.getComponentsFromOriginalGantt('Month');

		// Prepare window for printing

		// Get page template
		const pageTemplate = this.printWindow.document.querySelector('.templates .page');

		// Get pages container
		const pagesContainer = this.printWindow.document.querySelector('.pages');

		// Create a page for each quarter in the timeline
		// noinspection JSCheckFunctionSignatures
		const quarters = this.filterUnnecessaryPeriods(ganttInstance._getTimelineQuarters());

		for (const quarter of quarters) {
			// Break down period into chunks
			const chunks = this.getTasksChunks();

			const totalChunks = chunks.length
			chunks.forEach((chunk, index) => {
				////// Setup individual page
				const page = pageTemplate.cloneNode(true)

				// Set page title
				this.buildPageTitle(page, quarter, totalChunks, index + 1);

				// noinspection JSCheckFunctionSignatures
				this.buildPage(
					page,
					quarter,
					pagesContainer,
					originalSvg,
					dateAnchorContainer,
					stickyDatesHeader,
					chunk
				);
			})
		}
	}

	/**
	 * @param {SVGElement} page
	 * @param {GanttWrapper.TimelinePeriod} period
	 * @param {number} totalChunks
	 * @param {number} chunkIndex
	 */
	buildPageTitle(page, period, totalChunks, chunkIndex) {
		const titleContainer = page.querySelector('.page-title');

		const projectName = this.config.timelineName;
		const periodName = `${period.name} ${period.year}`;
		let taskChunkIndex = '';

		if (totalChunks > 1) {
			taskChunkIndex = `${chunkIndex}/${totalChunks}`
		}

		titleContainer.innerHTML = `
			<div style="display: flex; justify-content: space-between">
				<div
					class="project-name text-muted"
					style="max-width: 30%; width: 30%; text-align: left"
				>
					${projectName}
				</div>
				<div
					class="period-name"
					style="max-width: 30%; width: 30%; text-align: center; font-size: 1.2rem"
				>
					${periodName}
				</div>
				<div
					class="tasks-chunk-index text-muted"
					style="max-width: 30%; width: 30%; text-align: right"
				>
					${taskChunkIndex}
				</div>
			</div>
		`;
	}

	/**
	 * Takes cared of copying the SVG into the new page
	 * and 'Focusing' the relevant section for the given
	 * timeline period
	 *
	 * @param {HTMLElement} page
	 * @param {GanttWrapper.TimelinePeriod} pagePeriod
	 * @param {HTMLElement} pagesContainer
	 * @param {SVGElement} originalSvg
	 * @param {HTMLElement} dateAnchorContainer
	 * @param {HTMLElement} stickyDatesHeader
	 * @param {GanttWrapper.Task[]} chunk
	 */
	buildPage(
		page,
		pagePeriod,
		pagesContainer,
		originalSvg,
		dateAnchorContainer,
		stickyDatesHeader,
		chunk
	) {
		// Append page to DOM
		pagesContainer.appendChild(page);

		const pageGanttContainer = page.querySelector('.gantt-container');
		const pageGanttWrapperContainer = page.querySelector('.gantt-wrapper-container');
		// Append SVG to page

		/** @var {SVGElement} */
		const pageSvg = originalSvg.cloneNode(true);

		pageGanttContainer.appendChild(pageSvg);

		// Append date anchor points too
		/** @var {HTMLElement} */
		const pageAnchorPoints = dateAnchorContainer.cloneNode(true)

		pageGanttContainer.appendChild(pageAnchorPoints);

		// Append sticky dates container
		/** @var {HTMLElement} */
		const pageStickyDatesHeader = stickyDatesHeader.cloneNode(true)

		// Clear size
		pageStickyDatesHeader.style.left = '0';
		pageStickyDatesHeader.style.width = 'auto';

		pageGanttWrapperContainer.appendChild(pageStickyDatesHeader);

		const pageStickyDatesHeaderSvg = pageStickyDatesHeader.querySelector('svg');

		// Shift sticky dates vertically to hide month name, as
		// its already displayed on page header
		const datesHeaderHeight = 60;
		const stickyDatesHeaderInnerOffset = (datesHeaderHeight / 2);

		pageStickyDatesHeaderSvg.style.marginTop = `-${stickyDatesHeaderInnerOffset}px`;
		// We know that the height should be half of its inner content
		// So we explicitly make it so, so we that we can use its actual
		// height later
		pageStickyDatesHeader.style.height = `${stickyDatesHeaderInnerOffset}px`;

		////// Create tasks numbers/indexes

		const pageRowNumberContainer = this.createRowNumberContainer(pageSvg);

		////// 'Focus' relevant section of the SVG/Gantt

		// Get start of month anchor
		const periodStartDateString = formatDateForGanttChart(pagePeriod.startDate);
		const periodEndDateString = formatDateForGanttChart(pagePeriod.endDate);

		// We calculate the width of a given day by comparing the distance between
		// the first 2 anchors
		const firstAnchor = pageAnchorPoints.children[0];
		const secondAnchor = pageAnchorPoints.children[1];
		const dayWidth = parseInt(secondAnchor.dataset.x) - parseInt(firstAnchor.dataset.x);

		let periodStartAnchor = pageAnchorPoints.querySelector(`.anchor-point[data-date="${periodStartDateString}"]`)
		let periodEndAnchor = pageAnchorPoints.querySelector(`.anchor-point[data-date="${periodEndDateString}"]`)

		// If period anchors not found, use the first and last
		// found in the document respectively
		if (periodStartAnchor === null) {
			periodStartAnchor = pageAnchorPoints.children[0];
		}
		if (periodEndAnchor === null) {
			periodEndAnchor = pageAnchorPoints.children[pageAnchorPoints.children.length - 1];
		}

		// Calculate month width to fit it properly on the page
		const monthWidth =
			(parseInt(periodEndAnchor.dataset.x) + dayWidth) -
			parseInt(periodStartAnchor.dataset.x)

		// Get container width
		const pageWidth = pageGanttContainer.getBoundingClientRect().width;

		////// Prepare page scaling
		//// Horizontal Scaling
		const horizontalSvgScale = pageWidth / monthWidth;
		const horizontalSvgScaleUndo = 1 / horizontalSvgScale;

		//// Vertical Scaling
		const stickyHeaderActualHeight = pageStickyDatesHeader.getBoundingClientRect().height;
		const availableHeight = pageGanttContainer.getBoundingClientRect().height - stickyHeaderActualHeight;
		const taskRowHeight = pageSvg.querySelector('.grid-row').getBoundingClientRect().height;
		// Calculate required height as all the rows + the sticky dates header final height
		const requiredHeight = (taskRowHeight * this.getRowsPerPage());

		const verticalSvgScale = availableHeight / requiredHeight;
		const verticalSvgScaleUndo = 1 / verticalSvgScale;

		////// Prepare offsets
		//// Horizontal offsets
		const horizontalOffset = parseInt(periodStartAnchor.dataset.x) * horizontalSvgScale;

		//// Vertical offsets
		// We need to know how much we should shift the SVG to line up
		// the original dates header with the fake sticky one
		const datesHeaderAfterScaling = datesHeaderHeight * verticalSvgScale;
		const verticalOffsetToLineupHeader = (datesHeaderAfterScaling - stickyHeaderActualHeight);

		// Then add the height of one row to hide the title task row
		const initialVerticalOffset = verticalOffsetToLineupHeader + (taskRowHeight * verticalSvgScale);

		// And lastly we scroll down to the bar
		// related to the first task of the chunk
		const chunkFirstTaskRowYPosition =
			((this.getRelatedRowCoordinates(pageSvg, chunk[0])).rowY) -
			// We subtract the header and title row heights before scaling
			// so we end up with the first row at +0 vertical offset
			(datesHeaderHeight + taskRowHeight)
		;

		const finalVerticalOffset = initialVerticalOffset + (chunkFirstTaskRowYPosition * verticalSvgScale);

		//// Apply scaling
		// Apply scaling to page SVG
		pageSvg.style.transformOrigin = `top left`;
		pageSvg.style.transform = `scaleX(${horizontalSvgScale}) scaleY(${verticalSvgScale})`;

		// Also transform sticky dates header svg
		pageStickyDatesHeaderSvg.style.transformOrigin = `top left`;
		pageStickyDatesHeaderSvg.style.transform = `scaleX(${horizontalSvgScale})`;


		////// Apply offsets
		//// Vertical Offsets
		// Shift SVG vertically to start of page/chunk
		pageSvg.style.marginTop = `-${finalVerticalOffset}px`


		//// Horizontal Offsets
		// Shift SVG horizontally so the month starts at the start of page
		// while taking into account the horizontal scaling
		pageSvg.style.marginLeft = `-${horizontalOffset}px`

		// Also shift sticky dates header svg
		pageStickyDatesHeaderSvg.style.marginLeft = `-${horizontalOffset}px`

		// Also shift the rows index number container, using translate to shift its contents too
		// We undo the scaling however, because the position is on the SVG coordinates, before
		// they are scaled down by the CSS
		pageRowNumberContainer.setAttribute(
			'transform',
			`translate(${horizontalOffset * horizontalSvgScaleUndo},0)`
		)

		////  Unscale elements for original scaling

		// Unscale Text Tags
		pageSvg.querySelectorAll('text')
			.forEach(textTag => {
				// Scale text back to its original scale
				textTag.style.transform = `scaleX(${horizontalSvgScaleUndo}) scaleY(${verticalSvgScaleUndo})`;
				// But also shift its X & & coordinates to compensate for this scaling
				// Not sure why we need to scale it down twice, but it works...
				// noinspection JSCheckFunctionSignatures
				textTag.setAttribute(
					'x',
					parseInt(textTag.getAttribute('x')) * horizontalSvgScale
				)
				// noinspection JSCheckFunctionSignatures
				textTag.setAttribute(
					'y',
					parseInt(textTag.getAttribute('y')) * verticalSvgScale
				)
			})

		// Also do it for sticky header text tags, but only horizontally
		pageStickyDatesHeaderSvg.querySelectorAll('text')
			.forEach(textTag => {
				// Scale text back to its original scale
				textTag.style.transform = `scaleX(${horizontalSvgScaleUndo})`;
				// But also shift its X coordinate to compensate for this scaling
				// Not sure why we need to scale it down twice, but it works...
				// noinspection JSCheckFunctionSignatures
				textTag.setAttribute(
					'x',
					parseInt(textTag.getAttribute('x')) * horizontalSvgScale
				)
			})

		// Also unscale the hierarchy guidelines, by scaling its stroke width
		pageSvg.querySelectorAll('.real-path').forEach(path => {
			// We know the original stroke width is of 2px
			const originalWidth = 2;
			path.style.strokeWidth = `${originalWidth * horizontalSvgScaleUndo}px`;
		})

		// Also unscale width of row number rectangles
		pageSvg.querySelectorAll('.row-number').forEach(rowElement => {
			const rect = rowElement.querySelector('rect');
			const width = parseInt(rect.getAttribute('width'));
			rect.setAttribute(
				'width',
				(width * horizontalSvgScaleUndo).toFixed(2)
			);

			const text = rowElement.querySelector('text');
			const textX = parseInt(text.getAttribute('x'));
			text.setAttribute(
				'x',
				(textX * horizontalSvgScaleUndo).toFixed(2)
			);
		})
	}

	/**
	 * Re renders the original gantt in the editor view using the desired
	 * view type and returns the nodes required for printing
	 *
	 * @param {'Day'|'Month'|'Quarter'} type
	 * @return {Promise<{stickyDatesHeader: Node, originalSvg: Node, dateAnchorContainer: Node}>}
	 */
	async getComponentsFromOriginalGantt(type) {
		// Render original gantt in day view to get the SVG
		// that will be turned into a month export
		const ganttInstance = this.config.gantt;
		const originalViewType = ganttInstance._viewTypeSelect.value;

		// Get all collapsed tasks
		const collapsedTasks = ganttInstance._getTasks().filter(task => task.collapsed);

		// Uncollapse and un hide all tasks
		ganttInstance._getTasks().forEach(task => {
			task.collapsed = true;
			// Mark all tasks as hidden
			task.hidden = true;
		});

		// We use the task export to get the tasks that should go on the print
		this.getTasksToExport().forEach(task => {
			task.collapsed = false;
			task.hidden = false;
		})

		// If we selected task...
		if (typeof this.getTargetTask() !== 'string') {
			this.getTasksToExport().forEach(task => {
				ganttInstance._traverseParents(task, parent => {
					// ...Un hide parents
					parent.collapsed = false;
					parent.hidden = false;
				})
			})
		}

		//// Re render in required view mode
		// We need to refresh first to draw all the tasks/bars
		ganttInstance._fullRefresh({preserveHiddenStatus: true})
		ganttInstance._setViewType(type, false);

		// Wait a bit to make sure gantt has finished rendering
		await new Promise(r => setTimeout(r, 256));

		// Get original SVG from gantt instance
		const originalSvg = ganttInstance._svgContainer.cloneNode(true);
		// Get date anchor points container
		const dateAnchorContainer = ganttInstance._dateAnchorPointsContainer.cloneNode(true);
		// Get date anchor points container
		const stickyDatesHeader = ganttInstance._ganttDatesDuplicatedStickyHeaderContainer.cloneNode(true);

		// Restore tasks collapsed status
		collapsedTasks.forEach(task => task.collapsed = true);

		// Restore old view type
		ganttInstance._fullRefresh()
		ganttInstance._setViewType(originalViewType, false);

		this.cleanupSourceSvg(originalSvg);

		return {originalSvg, dateAnchorContainer, stickyDatesHeader};
	}

	/**
	 * Remove from the source SVG elements that are not relevant
	 * to the current export
	 *
	 * @param {SVGElement} originalSvg
	 */
	cleanupSourceSvg(originalSvg) {
		// Remove generic we don't care about from the original svg
		const elementsToBeRemoved = [
			'.hover-only-path',
			'.handle-group',
		];

		elementsToBeRemoved.forEach(elementClass => {
			originalSvg.querySelectorAll(elementClass).forEach(element => {
				element.remove();
			})
		})

		const targetTask = this.getTargetTask()

		if (targetTask) {
			// bars and hierarchy guidelines from tasks we don't care about
			const tasksToDisplay = this.getTasksToExport();
			const tasksIds = tasksToDisplay.map(task => task.id);

			// Remove bars we don't care about
			originalSvg.querySelectorAll('.bar-wrapper').forEach(wrapper => {
				const wrapperBelongsToExport = tasksIds.includes(wrapper.dataset.id);
				if (wrapperBelongsToExport === false) {
					wrapper.remove();
				}
			})

			// Remove hierarchy guidelines we don't care about
			originalSvg.querySelectorAll('.real-path').forEach(line => {
				const fromId = line.dataset.from;
				const toId = line.dataset.to;

				// We only care about lines that come from and go to tasks in this export
				if (
					tasksIds.includes(fromId) === false ||
					tasksIds.includes(toId) === false
				) {
					line.remove();
				}
			})
		}
	}

	/**
	 * Creates the tasks numbers/indices display that will
	 * go on each page
	 *
	 * @param {SVGElement} pageSvg
	 * @returns {SVGElement}
	 */
	createRowNumberContainer(pageSvg) {
		const tasksToDisplay = this.getTasksToExport();

		// Create a container for the indexes on the SVG
		const indexListContainerOnSvg = document.createElementNS('http://www.w3.org/2000/svg', 'g');

		indexListContainerOnSvg.classList.add('row-number-container')

		tasksToDisplay.forEach((task, index) => {
			// Find related bar for this task on the SVG
			const {expectedRowHeight, rowY} = this.getRelatedRowCoordinates(pageSvg, task);

			// Create container for individual index/id display
			const indexContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');

			indexContainer.classList.add('row-number')

			// Create visual rectangle for it
			const indexRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

			// We will position it horizontally by moving the parent group
			indexRect.setAttribute('x', '0');

			// Position vertically
			indexRect.setAttribute('y', rowY.toFixed(0));
			indexRect.setAttribute('height', expectedRowHeight.toFixed(0));
			indexRect.setAttribute('width', expectedRowHeight.toFixed(0));
			indexRect.setAttribute('fill', 'black');
			indexRect.setAttribute('fill-opacity', '0.15');
			indexRect.setAttribute('stroke', 'none');

			indexContainer.appendChild(indexRect);

			// Create text
			const textTag = document.createElementNS('http://www.w3.org/2000/svg', 'text');

			// We will position it horizontally by moving the parent group
			textTag.setAttribute('x', (expectedRowHeight / 2).toFixed(0));

			// Position vertically
			textTag.setAttribute('y', (rowY + (expectedRowHeight / 2)).toFixed(0));
			textTag.setAttribute('dominant-baseline', 'middle');
			textTag.setAttribute('text-anchor', 'middle');

			textTag.innerHTML = (index + 1).toFixed(0);

			indexContainer.appendChild(textTag);

			// Append to list container
			indexListContainerOnSvg.appendChild(indexContainer);
		})

		// Append container to page SVG
		pageSvg.appendChild(indexListContainerOnSvg);

		return indexListContainerOnSvg;
	}

	/**
	 * Returns the height and Y position of the row for the
	 * given task
	 *
	 * @param {SVGElement} pageSvg
	 * @param {GanttWrapper.Task} task
	 * @return {{expectedRowHeight: number, rowY: number}}
	 */
	getRelatedRowCoordinates(pageSvg, task) {
		const relatedBarWrapper = this.findRelatedBarWrapper(pageSvg, task);

		const barElement = relatedBarWrapper.querySelector('.bar')
		const barYPosition = parseInt(barElement.getAttribute('y'));
		const barHeight = parseInt(barElement.getAttribute('height'));

		// We know the row height should be 50px, and the bar is centered around it, so we
		// can the row position from it
		const expectedRowHeight = 50;

		const rowY =
			barYPosition - // Take the original bar Y position...
			((expectedRowHeight - barHeight) / 2); // ...and shift it up by the remaining vertical space from the row and divide it by two
		return {expectedRowHeight, rowY};
	}

	/**
	 * @param {SVGElement} pageSvg
	 * @param {GanttWrapper.Task} task
	 * @return {SVGElement}
	 */
	findRelatedBarWrapper(pageSvg, task) {
		return pageSvg.querySelector(`.bar-wrapper[data-id="${task.id}"]`);
	}

	/**
	 * Returns the tasks that needs to be displayed
	 * broken down in chunks of the given page size
	 *
	 * @returns {GanttWrapper.Task[][]}
	 */
	getTasksChunks() {
		const chunksSize = this.getRowsPerPage();

		const tasks = this.getTasksToExport();
		/** @var {GanttWrapper.Task[][]} */
		const chunks = [];

		for (let x = 0; x < tasks.length; x += chunksSize) {
			chunks.push(tasks.slice(x, x + chunksSize));
		}

		return chunks;
	}

	/**
	 * @return {GanttWrapper.Task[]}
	 */
	getTasksToExport() {
		const targetTask = this.getTargetTask();

		if (targetTask) {
			const tasksToExport = [targetTask];

			// Print only selected tasks and children
			this.config.gantt._traverseDescendants(targetTask, descendantTask => {
				tasksToExport.push(descendantTask);
			})

			return tasksToExport;
		} else {
			// If target task is null we are either printing all
			// tasks or only the printable ones

			const exportType = this.getTaskTargetSelect().value;

			if (exportType === 'all') {
				// Return all tasks
				return this.config.gantt._getTasks();

			} else {
				// Print all printable tasks
				return this.getPrintableTasks();
			}

		}
	}

	/**
	 * Removes unneeded time periods if a task was
	 * selected to be exported
	 *
	 * @param {GanttWrapper.TimelinePeriod[]} periods
	 * @return {GanttWrapper.TimelinePeriod[]}
	 */
	filterUnnecessaryPeriods(periods) {
		const targetTask = this.getTargetTask();
		const ganttInstance = this.config.gantt;
		if (targetTask) {
			const targetStartDate = ganttInstance._getCurrentStartDate(targetTask);
			const targetEndDate = ganttInstance._getCurrentEndDate(targetTask);

			// Get only periods where the given task
			// is displayed
			return periods.filter(period => {
				const endOfPeriodIsAfterStartOfTask = period.endDate.isSameOrAfter(targetStartDate);
				const startOfPeriodIsBeforeEndOfTask = period.startDate.isSameOrBefore(targetEndDate);

				return (endOfPeriodIsAfterStartOfTask && startOfPeriodIsBeforeEndOfTask)
			})
		}

		// Return with no filtering
		return periods;
	}

	////// Tasks Sheet Print Related Settings
	handleTasksPrintRequest() {
		// We default them to false because getInputsByName skip non filled checkboxes
		let columns = {
			'start_date': false,
			'end_date': false,
			'duration': false,
			'delays': false,
			'progress': false,
		}

		const columnsFromDom = getInputsByName(
			this.taskPrintSettings,
			[
				'start_date',
				'end_date',
				'duration',
				'delays',
				'progress',
			]
		);

		const printSettings = {
			columns: {...columns, ...columnsFromDom},
			paperSize: this.getPaperSize(),
		};

		const printAll = getInputsByName(this.taskPrintSettings, ['print_all']).print_all;

		showLoading();
		Axios.post(
			this.config.gantt._wrapperOptions.printTaskSheetRoute,
			{
				timelineExport: this.config.gantt._exportTimeline({
					allTasks: printAll,
				}),
				printSettings,
			})
			.then(response => {
				// noinspection JSUnresolvedReference
				window.open(response.data.downloadRoute, '_blank');
			})
			.catch(handleAjaxError)
			.finally(hideLoading);
	}

	/**
	 * Traverses sequentially through all descendants of the given tasks
	 * @param {GanttWrapper.ExportedTask} task
	 * @param {function(GanttWrapper.ExportedTask):void} callback
	 */
	traverseTaskExportDescendants(task, callback) {
		// Find direct descendants

		// Traverse them
		task.subTasks.forEach(childTask => {
			callback(childTask);

			this.traverseTaskExportDescendants(childTask, callback)
		})
	}

	/**
	 *
	 * @return {GanttWrapper.Task[]}
	 */
	getPrintableTasks() {
		const ganttInstance = this.config.gantt;
		const tasks = [];

		const exportTasks = ganttInstance._exportTimeline({
			allTasks: false,
		}).tasks;

		exportTasks.forEach(rootTask => {
			// Get visible root task
			const taskInstance = ganttInstance._findTaskById(rootTask.id);
			tasks.push(taskInstance);


			// And all their children
			this.traverseTaskExportDescendants(rootTask, (subTaskExport) => {
				const subTask = ganttInstance._findTaskById(subTaskExport.id);
				tasks.push(subTask);
			})
		})

		return tasks;
	}
}

export {TimelinePrintModal}
